import ViewBlocs from "@/components/view-blocs/view-blocs.vue"
import ViewHeader from "@/components/view-header/view-header.vue"

export default {
  name: 'Politics',
  components: { ViewBlocs, ViewHeader },
  props: {},
  computed: {},
  data () {
    return {}
  },
  created: function () { },
  mounted: function () { /* DOM accessible via this.$el */ },
  beforeUnmount: function () { /* clean all non-Vue listeners/objects */ },
  methods: {}
}
